<template>
  <v-dialog
    v-model="viewProfileDialog"
    persistent
    max-width="520"
    class="position-relative"
  >
    <v-card class="dialog-cls">
      <div class="dialog-close-btn">
        <v-tooltip bottom :color="$vuetify.theme.themes.light.tooltipColor">
          <template v-slot:activator="{ on: tooltip, attrs }">
            <v-btn
              icon
              @click="closeDialog"
              v-bind="attrs"
              v-on="{ ...tooltip }"
            >
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
          <span>Close</span>
        </v-tooltip>
      </div>
      <v-list class="pa-0">
        <v-list-item>
          <v-avatar
            v-if="
              contactInfo &&
                contactInfo.media &&
                contactInfo.media.length &&
                contactInfo.media[0].url
            "
            circle
            color="#344452"
            size="60"
          >
            <v-img :src="contactInfo.media[0].url"></v-img>
          </v-avatar>
          <v-avatar class="avatar-style" v-else circle size="60">
            <span class="avatar-initial">{{
              contactInfo | initial
            }}</span>
          </v-avatar>
          <v-list class="dialog-cls">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="dialog-title">
                  {{ contactInfo.firstName }} {{ contactInfo.lastName }}
                </v-list-item-title>
                <v-list-item-subtitle
                  class="default-chat-section"
                  v-if="comment.role"
                  >{{ comment.role.name || "N/A" }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-spacer></v-spacer>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list class="dialog-cls justify-center">
        <v-list-item>
          <v-row>
            <v-col cols="12">
              <v-list-item class="justify-center">
                <v-list-item-content>
                  <v-list-item-title class="dialog-title"
                    >Title</v-list-item-title
                  >
                  <v-list-item-subtitle class="dialog-text">{{
                    contactInfo.title || "N/A"
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                class="justify-center"
                v-if="
                  contactInfo.specialities.length > 0 &&
                    contactInfo.specialities[0].name
                "
              >
                <v-list-item-content>
                  <v-list-item-title class="dialog-title"
                    >Specializations</v-list-item-title
                  >
                  <v-row
                    v-if="
                      contactInfo.specialities &&
                        contactInfo.specialities.length > 0
                    "
                  >
                    <v-col
                      cols="12"
                      v-for="speciality in contactInfo.specialities"
                      :key="speciality._id"
                    >
                      <v-list-item-content
                        class="pa-0"
                        style="padding-left:2px !important"
                      >
                        <v-list-item-subtitle class="dialog-text">{{
                          speciality.name || "N/A"
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="justify-center" v-if="contactInfo.bio">
                <v-list-item-content>
                  <v-list-item-title class="dialog-title"
                    >Bio</v-list-item-title
                  >
                  <v-list-item-subtitle class="dialog-text  text-wrap">{{
                    contactInfo.bio || "N/A"
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-list-item>
      </v-list>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "ViewProfile",
  props: {
    comment: Object,
    viewProfileDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      contactInfo: this.comment.user
    };
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog", false);
    }
  }
};
</script>

<style scoped>
.avtar-cls {
  top: -83px;
  left: 0;
  right: 0;
  position: absolute;
  margin-left: 16px;
}
.avtar-parent {
  margin-top: 70px;
  position: relative;
}
.dialog-close-btn {
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 1;
}
.avatar-style {
  background-color: rgb(252, 252, 252);
  border: 1px solid #d6e0ef !important;
  border-color: rgb(252, 252, 252);
}
.avatar-initial {
  font-style: 'Now Alt';
  font-size: 28px;
  font-weight: 500;
  color: #000 !important;
  caret-color: #000 !important;
}
</style>
